import MailingService from "../services/mailing";
import { getStepsInformation, updateStepsInformation } from "./storage";

export const updateDiscussion = (text, data) => {
  const { codColigada, codLocal, codAtendimento } = getStepsInformation();
  updateStepsInformation(data);
  return new MailingService().updateDiscussion(
    text,
    codAtendimento,
    codLocal,
    codColigada
  );
};

export const onlyUpdateDiscussion = (text, codColigada, codLocal, codAtendimento) => {
  return new MailingService().updateDiscussion(
    text,
    codAtendimento,
    codLocal,
    codColigada
  );
};
